import { unwrap } from '@remote-medium/ui';

import { admin } from '../../../lib/client.ts';

/** One aggregate call: the queue is grouped per role on the server. */
export const loadOverview = () => unwrap(admin.overview.$get());

export type Overview = Awaited<ReturnType<typeof loadOverview>>;
